/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserAvatar_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProgressPanel_user$ref: FragmentReference;
declare export opaque type ProgressPanel_user$fragmentType: ProgressPanel_user$ref;
export type ProgressPanel_user = {|
  +id: string,
  +firstName: string,
  +lastName: string,
  +avatar: ?string,
  +$fragmentRefs: UserAvatar_user$ref,
  +$refType: ProgressPanel_user$ref,
|};
export type ProgressPanel_user$data = ProgressPanel_user;
export type ProgressPanel_user$key = {
  +$data?: ProgressPanel_user$data,
  +$fragmentRefs: ProgressPanel_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ProgressPanel_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avatar",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserAvatar_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e630f4feac23d0584908aac029c54637';
module.exports = node;
